import { createApp } from 'vue';
import App from './App.vue';
import {createPinia} from "pinia";
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';
import * as Sentry from "@sentry/vue";

const pinia = createPinia();
const app = createApp(App);

app.use(VCalendar, {});
app.use(pinia);

Sentry.init({
  app,
  dsn: "https://86c76f6d92c7eb4b1da51864ae339b78@o4507990696787968.ingest.us.sentry.io/4507990860824576",
  integrations: [
    Sentry.replayIntegration(),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

app.mount('#custom-checkout');